import { render, staticRenderFns } from "./UserMaintenancePayments.vue?vue&type=template&id=2e135dba&scoped=true&"
import script from "./UserMaintenancePayments.vue?vue&type=script&lang=js&"
export * from "./UserMaintenancePayments.vue?vue&type=script&lang=js&"
import style0 from "./UserMaintenancePayments.vue?vue&type=style&index=0&id=2e135dba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e135dba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VIcon,VRow,VSelect,VSimpleTable,VSpacer,VSubheader})
